import React, { FC }           from 'react';
import { useField }            from 'formik';
import styled                  from 'styled-components';
import {
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormControl as MuiFormControl,
}                              from '@material-ui/core';
import { EBackdropType }       from '@enums/nationalAdManagement';
import { backdropTypeOptions } from '@modules/nationalAdManager/utils/suggestions';

const FormControl = styled(MuiFormControl)`
  && {

    @media(min-width: 960px) {
      margin: 60px 0 0 80px;
    }

    @media(min-width: 1280px) {
      margin: 80px 0 0 100px;
    }

    [class^="MuiFormLabel"] {
      font-size : 24px;
      color     : ${({ theme: { textColor } }): string => textColor.gray} !important;
    }

    [class^="MuiFormGroup"] {
      margin-top  : 24px;
      margin-left : 30px;
    }

    [class^="MuiFormControlLabel"] {
      [class^="MuiTypography"] {
        font-size   : 18px;
        font-weight : 300;
        margin-left : 10px;
      }
    }
  }
`;

interface IProps {
  name: string;
}

export const BackdropRadioGroup: FC<IProps> = ({ name }) => {
  const [field, , helpers] = useField<EBackdropType>(name);

  return (
    <FormControl>
      <FormLabel>Choose a backdrop</FormLabel>

      <RadioGroup
        {...field}
        onChange   = {(event, value) => helpers.setValue(+value)}
        aria-label = "Backdrop Type"
      >
        {backdropTypeOptions.map((backdrop) => (
          <FormControlLabel
            key     = {backdrop.value}
            value   = {backdrop.value}
            label   = {backdrop.label}
            control = {<Radio />}
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
};
